import { format } from 'date-fns';

import { CustomerReportItem } from '@/features/slice/report';

export const mapCustomerReportListToCsvExport = (
    customers: Array<CustomerReportItem>,
) => {
    if (customers.length === 0) {
        return [];
    }

    return customers.map((customer) => {
        return {
            Name: customer.name,
            'Customer Since': format(customer.created_at, 'dd-MM-yyyy'),
            'Customer Type': customer.customer_type,
            Email: customer.email,
            'Phone Number': customer.phone_number,
            Address: customer.address,
            'Total Orders': customer.total_orders,
            'Total Price': customer.total_price,
            'Total Paid': customer.total_paid,
            'Total Due': customer.total_due,
            'Last Order Date':
                customer.last_order_date &&
                format(new Date(customer.last_order_date), 'dd-MM-yyyy'),
        };
    });
};
